module.exports = "/_next/static/images/mitra-1-eff85f45950303b9fd584dd4477b1342.jpeg";